import { Cancel, Send } from '@mui/icons-material';
import {
  Box,
  Button,
  Container,
  Stack,
  Step,
  StepButton,
  Stepper,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useValue } from '../../context/ContextProvider';
import AddTagDetails from './AddTagDetails'
import AddDetails from '../addPoint/addDetails/AddDetails';
import AddImages from '../addPoint/addImages/AddImages';
import AddLocation from '../addPoint/addLocation/AddLocation';
import { clearPoint, createPoint, updatePoint } from '../../actions/point';
import { clearTag, createTag, updateTag } from '../../actions/tag';
import { useNavigate } from 'react-router-dom';

const AddTag = () => {
  const {
    state: {
      tagDetails,
      currentUser,
      updatedTag
    },
    dispatch,
  } = useValue();
  const [activeStep, setActiveStep] = useState(0);
  const [steps, setSteps] = useState([
    { label: 'Tags', completed: true }/*,
    { label: 'Details', completed: false },
    { label: 'Images', completed: false },*/
  ]);
  const [showSubmit, setShowSubmit] = useState(true);
  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((activeStep) => activeStep + 1);
    } else {
      const stepIndex = findUnfinished();
      setActiveStep(stepIndex);
    }
  };
  const checkDisabled = () => {
    if (activeStep < steps.length - 1) return false;
    const index = findUnfinished();
    if (index !== -1) return false;
    return false;
  };
  const findUnfinished = () => {
    return steps.findIndex((step) => !step.completed);
  };

  /*useEffect(() => {
    if (images.length) {
      if (!steps[2].completed) setComplete(2, true);
    } else {
      if (steps[2].completed) setComplete(2, false);
    }
  }, [images]);*/
  useEffect(() => {
    if (tagDetails.Tagtitle.length > 1 ) {
      if (!steps[0].completed) setComplete(0, true);
    } else {
      if (steps[0].completed) setComplete(0, true);
    }
  }, [tagDetails]);
  /*useEffect(() => {
    if (location.lng || location.lat) {
      if (!steps[0].completed) setComplete(0, true);
    } else {
      if (steps[0].completed) setComplete(0, false);
    }
  }, [location]);*/
  const setComplete = (index, status) => {
    setSteps((steps) => {
      steps[index].completed = status;
      return [...steps];
    });
  };
  useEffect(() => {
    if (findUnfinished() === -1) {
      if (!showSubmit) setShowSubmit(true);
    } else {
      if (showSubmit) setShowSubmit(true);
    }
  }, [steps]);

  const handleSubmit = () => {
    const tag = {
      title: tagDetails.Tagtitle,
      id: tagDetails.uid,
      name: tagDetails.uName

    };  
    /*if (updatedTag)
      return updateTag(
        tag,
        currentUser, 
        dispatch,
        updatedTag
      );*/
    createTag(tag, currentUser, dispatch);
  };

  const navigate = useNavigate();
  const handleCancel = () => {
    /*if (updatedPoint) {
      navigate('/dashboard/points');
      clearPoint(dispatch, currentUser, addedImages, updatedPoint);
    } else {*/
      dispatch({ type: 'UPDATE_SECTION', payload: 0 });
      /*clearPoint(dispatch, currentUser, images);
    }*/
  };
  return (
    <Container sx={{ my: 4 }}>
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={activeStep}
        sx={{ mb: 1 }}
      >
        {steps.map((step, index) => (
          <Step key={step.label} completed={step.completed}>
            <StepButton onClick={() => setActiveStep(index)}>
              {step.label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <Box sx={{ pb: 7 }}>
        {
          {
            0: <AddTagDetails />
          }[activeStep]
        }

        <Stack direction="row" sx={{ pt: 2, justifyContent: 'space-around' }}>
          <Button
            color="inherit"
            disabled={!activeStep}
            onClick={() => setActiveStep((activeStep) => activeStep - 1)}
          >
            Back
          </Button>
          <Button disabled={checkDisabled()} onClick={handleNext}>
            Next
          </Button>
        </Stack>

        <Stack
          sx={{ alignItems: 'center', justifyContent: 'center', gap: 2 }}
          direction="row"
        >
          {showSubmit && (
            <Button
              variant="contained"
              endIcon={<Send />}
              onClick={handleSubmit}
            >
              {/*updatedTag ? 'Update' : */'Submit'}
            </Button>
          )}
          <Button
            variant="outlined"
            endIcon={<Cancel />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default AddTag;